<template>
  <div class="student-statistic">
    <div class="statistic-head" v-if="titleNumber !== '1'">
      <div class="statistic-head__num">{{titleNumber}}</div>
      <div class="statistic-head__title">{{titleName}}</div>
    </div>
    <ul class="statistic-list" v-if="studyResults">
        <li class="statistic-list__item"  v-for="(item,index) in statisticList"
        :key="`item_${index}`">
          <div class="item-title">
            {{item.title}}
             <el-popover
              placement="top"
              title="说明"
              width="200"
              trigger="hover"
              :content="item.content"
              v-if="item.id<4||item.id===6"
              >
              <img slot="reference"
              src="../../images/why-icon.png" class="item-title__tooltip" alt="">
            </el-popover>
          </div>
          <div class="item-num">
            {{item.num}}
            <span class="item-unit">{{item.unit}}</span>
          </div>
          <div class="item-detail" >
          {{item.detail}}
          </div>
        </li>
      </ul>
       <div v-else>
      <Empty content="暂无数据~"/>
     </div>
  </div>
</template>

<script>
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'StudyStatistic',
  props: {
    titleName: {
      type: String,
      default: '智适应学习概览',
    },
    titleNumber: {
      type: String,
      default: '01',
    },
    subjectId: {
    },
    studyResults: {
    },
  },
  components: {
    Empty,
  },
  data() {
    return {
      // 理科列表
      scienceList: [
        {
          title: '知识点测学总个数',
          num: '',
          unit: '个',
          id: 0,
          content: '测学知识点 = 测试或学习过的知识点（一个知识点若被学习多次，会统计多次）',
        },
        {
          title: '漏洞知识点个数',
          num: '',
          unit: '个',
          id: 1,
          content: '漏洞知识点 = 在测试环节测出的薄弱知识点'
          + '\n\r'
          + '（一个知识点被多人学习多次，会统计多次)',
        },
        // {
        //   title: '学完知识点个数',
        //   num: '',
        //   unit: '个',
        //   id: 2,
        //   content: '学完知识点 = 在学习环节学完的知识点'
        //   + '\n\r'
        //    + '（一个知识点被多人学习多次，会统计多次)',
        // },
        {
          title: '攻克薄弱知识点个数',
          num: '',
          unit: '个',
          id: 3,
          content: '攻克知识点 = 在学习环节学完且学后掌握的知识点'
          + '\n\r'
          + '（一个知识点被多人学习多次，会统计多次)',
        },
        {
          title: '总答题数', num: '', unit: '道', id: 4,
        },
        {
          title: '平均正确率', num: '', unit: '%', id: 5,
        },
        {
          title: '学习时长', num: '', unit: '分钟', id: 6, detail: '人均看视频', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
      // 语文列表
      chineseList: [
        {
          title: '总答题数', num: '', unit: '道', id: 4,
        },
        {
          title: '主观题平均得分率', num: '', unit: '%', id: 5,
        },
        {
          title: '学习时长', num: '', unit: '分钟', id: 6, detail: '看视频', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
      // 英语列表
      englishList: [
        {
          title: '总答题数', num: '', id: 4, unit: '道',
        },
        {
          title: '平均正确率', num: '', id: 5, detail: '看视频', unit: '%',
        },
        {
          title: '学习时长', num: '', id: 6, detail: '看视频', unit: '分钟', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
    };
  },
  computed: {
    statisticList() {
      // if (this.subjectId === 1) {
      //   return this.englishList;
      // } if (this.subjectId === 3) {
      //   return this.chineseList;
      // }
      return this.scienceList;
    },
  },
  watch: {
    studyResults() {
      this.initData();
    },
  },
  methods: {
    initData() {
      this.scienceList[0].num = this.studyResults.study_code_num;
      this.scienceList[1].num = this.studyResults.leak_code_num;
      this.scienceList[2].num = this.studyResults.conquer_code_num;
      this.scienceList[3].num = this.studyResults.question_num;
      this.scienceList[4].num = this.studyResults.obj_avg_score_ratio;
      this.scienceList[5].num = this.studyResults.avg_total_time;
      this.scienceList[5].detail = `看视频${this.studyResults.avg_video_time}分钟   练习${this.studyResults.avg_exercise_time}分钟`;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-statistic{
  padding-top:30px;
  .statistic-head{
    display: flex;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      text-align: center;

    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);

    }
  }
  .statistic-list{
    display: flex;
    flex-flow: wrap;
    margin-top:30px;
    &__item{
      width: 242px;
      height: 156px;
      background: #F0F2F8;
      border-radius: 12px;
      margin: 0 15px 24px 0;
      .item-title{
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #808BAA;
        padding-top: 24px;

         &__tooltip {
          display: inline-block;
          width: 16px;
          height: 16px;
          text-align: center;
          vertical-align:text-bottom;
        }
      }
      .item-num{
        font-size: 36px;
        text-align: center;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        padding-top: 15px;
        color: #1989FA;
        .item-unit{
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 500;
          color: #586077;
        }
      }
      .item-detail{
        font-size: 14px;
        padding-top: 5px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #303133;
      }
    }
  }
}

</style>
